import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-03e8712c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "request-notifications__title" }
const _hoisted_2 = { class: "request-notifications__text" }
const _hoisted_3 = { class: "request-notifications__text" }

import { useNotifications } from '@/composables/useNotifications';
import { useRequestNotificationsShowedPrefs } from '@/stores/preferences';

import BaseModal from '@/components/modals/BaseModal.vue';
import { useInternalization } from '@/composables/useInternalization';


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestNotificationsModal',
  props: {
    isOpened: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { notificationService } = useNotifications();
const { t } = useInternalization();

function handleNext() {
  notificationService.registerNotifications(true);
  handleClose();
}

function handleClose() {
  const { set } = useRequestNotificationsShowedPrefs();
  set('yes');
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-opened": props.isOpened,
    class: "request-notifications",
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('modals.requestNotificationsTitle')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('modals.requestNotificationsText')), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('modals.requestNotificationsTextSmall')), 1),
      _createElementVNode("button", {
        type: "button",
        class: "request-notifications__button",
        onClick: handleNext
      }, _toDisplayString(_unref(t)('next')), 1)
    ]),
    _: 1
  }, 8, ["is-opened"]))
}
}

})